export const EVENT_IDENTIFIER_KEYS_TO_INVALIDATE_ON = [
  'instanceupdated',
  'instancedeleted',
  'instancecreated',
];
